import './Pricing.css';

function Pricing() {
  return (
    <section className="pricing-section" id="services">
      <div className="pricing-container" >
        <header className="pricing-header">
          <h2>Services Offered</h2>
          <p>
            We go beyond a simple wash — our expert detailing restores your
            vehicle’s appearance, protects its value, and keeps it in top condition for years to come.
          </p>
        </header>

        <div className="pricing-grid">
          <article className="pricing-card">
            <h3 className="pricing-title">Basic Interior</h3>
            <ul className="pricing-list">
              <li>Vacuum</li>
              <li>Wipe Down</li>
              <li>Windows / Door Jambs</li>
              <li>Floor Mats</li>
            </ul>
            <div className="pricing-footer">$225</div>
          </article>

          <article className="pricing-card">
            <h3 className="pricing-title">Basic In & Out</h3>
            <ul className="pricing-list">
              <li>Vacuum</li>
              <li>Wipe Down </li>
              <li>Windows / Door Jambs</li>
              <li>Exterior Wash & Spot Free Dry</li>
            </ul>
            <div className="pricing-footer">$275</div>
          </article>
        </div>

        <div className="pricing-grid">
          <article className="pricing-card pricing-card--inverted">
            <h3 className="pricing-title">Premium Interior</h3>
            <ul className="pricing-list">
              <li>Vacuum</li>
              <li>Wipe Down </li>
              <li>Windows / Door Jambs</li>
              <li>Floor Mats</li>
              <li>Steam Clean</li>
              <li>Stain Removal</li>
              <li>Air Freshener</li>
            </ul>
            <div className="pricing-footer">$300</div>
          </article>
          
          <article className="pricing-card pricing-card--inverted">
            <h3 className="pricing-title">Premium In & Out</h3>
            <ul className="pricing-list">
              <li>Vacuum</li>
              <li>Wipe Down </li>
              <li>Windows / Door Jambs</li>
              <li>Exteriror Wash & Spot Free Dry</li>
              <li>Steam Clean</li>
              <li>Stain Removal</li>
              <li>Paint Decontamination - Clay Bar</li>
              <li>Wax Finish - Shine & Protection</li>
            </ul>
            <div className="pricing-footer">$350</div>
          </article>
        </div>
      </div>
    </section>

  )
}

export default Pricing